import aaPartnership from './airAmbulance';

export const partnershipReducers = {
  aaPartnership,
};
